import { useEffect, useRef, useState } from 'react'
import { Col, Form, Input, Row, Select, Switch, message } from 'antd'
import { SFuncModal, SGeneralForms } from 'shj-components'
import { copyServiceNodeConfig } from '@/services/serviceConfig'
const { Option } = Select;
const CopyModalDom = (props) => {
    console.log(props)
    const [form] = Form.useForm();
    const { onClose, fn, record } = props
    const [submitLoading, setSubmitLoading] = useState<boolean>(false)
    const statusList = [{ label: '启用', value: true }, { label: '禁用', value: false }];
    const initFn = () => {
        form.setFieldsValue({ oldName: record.name, id: record.id })
    }
    useEffect(() => {
        initFn()
    }, [])
    // 提交
    const onFinish = () => {
        form.validateFields().then((values: any) => {
            setSubmitLoading(true)
            copyServiceNodeConfig(values).then((res) => {
                setSubmitLoading(false)
                message.success(res.message || "操作成功")
                onClose?.()
                fn && fn();
            }).catch(() => {
                setSubmitLoading(false)
            })
        })
    };

    return (
        <SFuncModal.Content
            onCancel={onClose}
            confirmLoading={submitLoading}
            onOk={onFinish}
        >
            <Form
                form={form}
                layout="vertical"
                autoComplete="off"
            >
                <Row>
                    <Form.Item label={'id'} name={'id'} hidden></Form.Item>
                    <Col span={24}>
                        <Form.Item label="原服务名称" name="oldName">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="服务名称" name="name"
                            rules={[{ required: true, message: '请填写服务名称' }]}>
                            <Input placeholder="请输入服务名称" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label="状态" name="enabled" initialValue={true} valuePropName="checked">
                                <Switch checkedChildren="启用" unCheckedChildren="禁用"/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </SFuncModal.Content>
    )
}

export function CopyModal(props) {
    const { fn, title, ...rest } = props
    let dialog: any = 0
    const onClose = () => {
        ; (dialog as any)?.destroy()
    }
    dialog = SFuncModal({
        width: 500,
        vanish: true,
        title: `${title}`,
        content: (
            <CopyModalDom onClose={onClose} fn={fn} {...rest} />
        ),
    })

    return dialog
}
